import { render, staticRenderFns } from "./ConnectingThroughTouchpoints.vue?vue&type=template&id=626bdb3e&"
import script from "./ConnectingThroughTouchpoints.vue?vue&type=script&lang=js&"
export * from "./ConnectingThroughTouchpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports